import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installGlobalErrorLogging } from './utils/errorLogger';
import { initAnalyticsWithConsent } from './firebase';

installGlobalErrorLogging();
// Opt-out model: starts analytics on load unless the user has explicitly
// declined. No-op if analytics isn't build-time enabled.
initAnalyticsWithConsent();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
